import { State } from '../Store';

export const selectMaintenanceStatuses = (state: State) =>
  state.maintenanceStatuses;
